// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/3dot.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------ LEXUS THEME --------------------- */

.lexus-nav-link {
    color: #252525
}

.lexus-nav-link:hover {
    background-color:#252525;
    color: white;  
}

.lexus-nav-link:focus {
    background-color: #252525;
    color: white;
}
.programHeader {
    margin-left: 17px;
    font-weight: bolder;
    min-width: 213px !important;
}

.lexus-nav-link.selectedMenu {
    background-color: #252525 !important;
    color: white!important;
}

.redFont {
    color:#e50000 !important;
}
.blackFont {
    color:#000000 !important;
}

/* ------------------ LEXUS THEME --------------------- */



/* ------------------ TOYOTA THEME --------------------- */

.toyota-nav-link {
    color: black;
}
.toyota-nav-link:focus {
    background-color: #e50000;
    color: white;
}

.toyota-nav-link:hover {
    color: white;
    background-color: #e50000;
}

.toyota-nav-link.selectedMenu {
    background-color: #e50000!important;
    color: white!important;
}

/* ------------------ TOYOTA THEME --------------------- */





.navbar-global {
    background-color: indigo;
}

.navbar-global .navbar-brand {
    color: white;
}

.navbar-global .navbar-user>li>a {
    color: white;
}

.navbar-primary {
    background-color: #333;
    bottom: 0px;
    left: 0px;
    position: absolute;
    top: 51px;
    width: 200px;
    z-index: 8;
    overflow: hidden;
    transition: all 0.1s ease-in-out;
}

.navbar-primary.collapsed {
    width: 60px;
}

.navbar-primary.collapsed .glyphicon {
    font-size: 22px;
}

.navbar-primary.collapsed .nav-label {
    display: none;
}

.custom-badge>span {
    margin-top: 0px;
    position: absolute;
    box-shadow: none!important;
    margin-left: -5px;
    font-size: 1.0em;
    font-weight: bold;
    padding-top: 0.4em;
}

.user_name {
    font-size: 0.8em;
    font-weight: bold;
}

.user_role {
    font-size: 0.7em;
}

.dd_item {
    /* padding-left: 5%!important;
    padding-right: 5%!important;
    padding-top: 2%!important;
    padding-bottom: 2%!important;
    margin-right: 10px; */
    padding: 5px 10px !important;
}

.theme_logo {
    vertical-align: baseline;
}

.toyota-icon {
    color: #e50000;
}

.lexus-icon {
    color: #424242
}

.divider {
    margin: 5px!important;
}

.container-fluid {
    padding-bottom: 2% !important;
    width: 99%;
    font-family: "Arial", sans-serif;
}

.activityTable .dropdown-menu {
    top: -18px;
left: 104px;
font-size: 12px;
}


.footer-font {
    color: black!important;
    font-weight: 400;
    border-top: 0.01em solid lightgray;
}

nav.navbar {
    height: 3.375rem;
    font-family: arial;
}

.navbar-nav {
    font-size: 1.0rem;
    margin-right:auto;
}

nav.navbar a.nav-link {
    line-height: 2rem;
    height: 3.375rem;
}

img.tp-nav-divider {
    border-right: solid 0.125rem;
    padding:0px 10px;
    height: 40px;
}


.navbar div.navbar-brand {
    margin: 0 6rem 0 0;
}

.form-control{
    font-size: 0.81rem !important;
}


.collapse.navbar-collapse, .collapse.navbar-collapse ul,.collapse.navbar-collapse ul li,.collapse.navbar-collapse ul li a{
    height: inherit;
}


.program_dots .program_0:hover{
    background-color: transparent;  
}

.ket_program{
    cursor: pointer;
}

.program_dots{ 
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 35px;
    width: 10px;
    float: right;
    background-repeat: no-repeat;
    background-position: center;       
}

.program_text{
    display: inline-flex;
    margin-right: 5px;
    /* width: 6rem; */
    text-align: center;  
    color: white;
    float: left;
    display: inline-block;

   
}

.program_text a{
   margin-right: 0px !important;
   outline: none;

}

.program_text a:focus, .program_text a:hover, .program_container .dropdown-item:active, .program_container,.program_container button.dropdown-item{
    background-color: transparent !important;
}

.program_container div.dropdown-menu.show{
    top:38px !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/container/components/index.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;;AAEA,yDAAyD;;;;AAIzD,0DAA0D;;AAE1D;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA,0DAA0D;;;;;;AAM1D;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,gBAAgB;IAGhB,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;;;;yBAIqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd,WAAW;AACX,eAAe;AACf;;;AAGA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;IACI,eAAe;AACnB;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yDAA2D;IAC3D,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qBAAqB;;;AAGzB;;AAEA;GACG,4BAA4B;GAC5B,aAAa;;AAEhB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* ------------------ LEXUS THEME --------------------- */\n\n.lexus-nav-link {\n    color: #252525\n}\n\n.lexus-nav-link:hover {\n    background-color:#252525;\n    color: white;  \n}\n\n.lexus-nav-link:focus {\n    background-color: #252525;\n    color: white;\n}\n.programHeader {\n    margin-left: 17px;\n    font-weight: bolder;\n    min-width: 213px !important;\n}\n\n.lexus-nav-link.selectedMenu {\n    background-color: #252525 !important;\n    color: white!important;\n}\n\n.redFont {\n    color:#e50000 !important;\n}\n.blackFont {\n    color:#000000 !important;\n}\n\n/* ------------------ LEXUS THEME --------------------- */\n\n\n\n/* ------------------ TOYOTA THEME --------------------- */\n\n.toyota-nav-link {\n    color: black;\n}\n.toyota-nav-link:focus {\n    background-color: #e50000;\n    color: white;\n}\n\n.toyota-nav-link:hover {\n    color: white;\n    background-color: #e50000;\n}\n\n.toyota-nav-link.selectedMenu {\n    background-color: #e50000!important;\n    color: white!important;\n}\n\n/* ------------------ TOYOTA THEME --------------------- */\n\n\n\n\n\n.navbar-global {\n    background-color: indigo;\n}\n\n.navbar-global .navbar-brand {\n    color: white;\n}\n\n.navbar-global .navbar-user>li>a {\n    color: white;\n}\n\n.navbar-primary {\n    background-color: #333;\n    bottom: 0px;\n    left: 0px;\n    position: absolute;\n    top: 51px;\n    width: 200px;\n    z-index: 8;\n    overflow: hidden;\n    -webkit-transition: all 0.1s ease-in-out;\n    -moz-transition: all 0.1s ease-in-out;\n    transition: all 0.1s ease-in-out;\n}\n\n.navbar-primary.collapsed {\n    width: 60px;\n}\n\n.navbar-primary.collapsed .glyphicon {\n    font-size: 22px;\n}\n\n.navbar-primary.collapsed .nav-label {\n    display: none;\n}\n\n.custom-badge>span {\n    margin-top: 0px;\n    position: absolute;\n    box-shadow: none!important;\n    margin-left: -5px;\n    font-size: 1.0em;\n    font-weight: bold;\n    padding-top: 0.4em;\n}\n\n.user_name {\n    font-size: 0.8em;\n    font-weight: bold;\n}\n\n.user_role {\n    font-size: 0.7em;\n}\n\n.dd_item {\n    /* padding-left: 5%!important;\n    padding-right: 5%!important;\n    padding-top: 2%!important;\n    padding-bottom: 2%!important;\n    margin-right: 10px; */\n    padding: 5px 10px !important;\n}\n\n.theme_logo {\n    vertical-align: baseline;\n}\n\n.toyota-icon {\n    color: #e50000;\n}\n\n.lexus-icon {\n    color: #424242\n}\n\n.divider {\n    margin: 5px!important;\n}\n\n.container-fluid {\n    padding-bottom: 2% !important;\n    width: 99%;\n    font-family: \"Arial\", sans-serif;\n}\n\n.activityTable .dropdown-menu {\n    top: -18px;\nleft: 104px;\nfont-size: 12px;\n}\n\n\n.footer-font {\n    color: black!important;\n    font-weight: 400;\n    border-top: 0.01em solid lightgray;\n}\n\nnav.navbar {\n    height: 3.375rem;\n    font-family: arial;\n}\n\n.navbar-nav {\n    font-size: 1.0rem;\n    margin-right:auto;\n}\n\nnav.navbar a.nav-link {\n    line-height: 2rem;\n    height: 3.375rem;\n}\n\nimg.tp-nav-divider {\n    border-right: solid 0.125rem;\n    padding:0px 10px;\n    height: 40px;\n}\n\n\n.navbar div.navbar-brand {\n    margin: 0 6rem 0 0;\n}\n\n.form-control{\n    font-size: 0.81rem !important;\n}\n\n\n.collapse.navbar-collapse, .collapse.navbar-collapse ul,.collapse.navbar-collapse ul li,.collapse.navbar-collapse ul li a{\n    height: inherit;\n}\n\n\n.program_dots .program_0:hover{\n    background-color: transparent;  \n}\n\n.ket_program{\n    cursor: pointer;\n}\n\n.program_dots{ \n    background-image: url(\"../../../../public/images/3dot.png\");\n    height: 35px;\n    width: 10px;\n    float: right;\n    background-repeat: no-repeat;\n    background-position: center;       \n}\n\n.program_text{\n    display: inline-flex;\n    margin-right: 5px;\n    /* width: 6rem; */\n    text-align: center;  \n    color: white;\n    float: left;\n    display: inline-block;\n\n   \n}\n\n.program_text a{\n   margin-right: 0px !important;\n   outline: none;\n\n}\n\n.program_text a:focus, .program_text a:hover, .program_container .dropdown-item:active, .program_container,.program_container button.dropdown-item{\n    background-color: transparent !important;\n}\n\n.program_container div.dropdown-menu.show{\n    top:38px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
